module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" Проект ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-2": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 md9"
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('v-card-title', [_c('h2', [_vm._v(_vm._s(_vm.Project.name))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Статус:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.status))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Объем закупки:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.quantity) + " из " + _vm._s(_vm.Project.maxQuantity))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Сумма:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.sum) + " из " + _vm._s(_vm.Project.maxSum))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Плановая дата старта:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.dateStart))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Плановая дата закрытия:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.dateExpected))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Ожидаемая прибыль (%):")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.profitExpected))])], 1), _vm._v(" "), (_vm.Project.my) ? _c('v-list-tile', [_c('h3', [_vm._v("Мои инвестиции")])]) : _vm._e(), _vm._v(" "), (_vm.Project.my) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Инвестированная сумма:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.sumMy))])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.Project.status == 'открыт') ? _c('v-flex', {
    staticClass: "xs12 md8",
    attrs: {
      "my-4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('v-card-title', [_c('h4', [_vm._v("Инвестирование")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('h5', [_vm._v("Вы можете инвестировать в этот проект максимально " + _vm._s(_vm.Project.maxSum - _vm.Project.sum) + " руб.")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs-4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "suminput",
    attrs: {
      "label": "Сумма",
      "type": "number",
      "rules": [_vm.rules.required, _vm.rules.positive]
    },
    model: {
      value: (_vm.sum),
      callback: function($$v) {
        _vm.sum = $$v
      },
      expression: "sum"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs-8": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.invest()
      }
    }
  }, [_vm._v("Инвестировать")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 4000,
      "top": true,
      "bottom": false,
      "right": true,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Закрыть")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6078ca6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectCard.vue
// module id = 469
// module chunks = 1